import { AppThunk } from "../rootStore";
import {
  setAthletesList,
  setLimitAthletesList,
  setLoadingAtletes,
  setTotalAthletesList,
  setOffsetAthletesList,
} from "./athleteSlice";
import { CommonApiParams } from "../../types/common";
import { ClinicRepository } from "../../repositories/ClinicRepository";
import { SUPER_ADMIN_CLINIC_LIMIT } from "../../constants/dashboard";
import { removeRequest } from "../LoadingStore/loadingSlice";
import { Requests } from "../../types/requests";

export const getAthletes =
  (
    superAdminId: string | undefined,
    callback?: () => void,
    replaceItems?: boolean
  ): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoadingAtletes(true));

      const {
        athletes: { atheletesList, offsetAthletesList, limitAtheletesList },
      } = getState();

      const apiParams: CommonApiParams = {
        limit: limitAtheletesList,
        offset: replaceItems ? 0 : offsetAthletesList,
      };

      const clinicRepository = ClinicRepository.getInstance();
      const atheletesListResponse = await clinicRepository.getAtletesList(
        superAdminId,
        apiParams
      );
      const items = atheletesListResponse?.items;
      const oldItems = atheletesList || [];
      dispatch(setAthletesList(replaceItems ? items : [...oldItems, ...items]));
      dispatch(setTotalAthletesList(atheletesListResponse?.totalCount));
      dispatch(
        setOffsetAthletesList(
          replaceItems
            ? SUPER_ADMIN_CLINIC_LIMIT
            : offsetAthletesList + SUPER_ADMIN_CLINIC_LIMIT
        )
      );
    } catch (error) {
      console.log("Error from getClinicList Thunk", error);
    } finally {
      dispatch(setLoadingAtletes(false));
      dispatch(removeRequest(Requests.getClinicList));

      if (callback) callback();
    }
  };

export const goToPageAthletes =
  (superAdminId: string | undefined, page: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoadingAtletes(true));

      const {
        athletes: { limitAtheletesList },
      } = getState();

      const newOffset = (page - 1) * limitAtheletesList;
      const apiParams: CommonApiParams = {
        limit: limitAtheletesList,
        offset: newOffset,
      };

      const clinicRepository = ClinicRepository.getInstance();
      const atheletesListResponse = await clinicRepository.getAtletesList(
        superAdminId,
        apiParams
      );
      dispatch(setAthletesList(atheletesListResponse?.items));
      dispatch(setTotalAthletesList(atheletesListResponse?.totalCount));
      dispatch(setOffsetAthletesList(newOffset));
    } catch (error) {
      console.log("Error from goToPageAthletes Thunk", error);
    } finally {
      dispatch(setLoadingAtletes(false));
      dispatch(removeRequest(Requests.getClinicList));
    }
  };
